module.exports = "/_next/static/images/Frame-2ddb5cf57418c649724f9dc17b1c6a4f.webp";